export default __webpack_public_path__ + "static/media/01_lesnicka-brasna.1241f9d4.jpg";